import {
    ActionCreatorWithPayload,
    CaseReducer,
    createAsyncThunk,
} from '@reduxjs/toolkit'
import {
    NinchatChannelJoinedEvent,
    NinchatEventType,
} from '../types/events'
import {
    NinchatEventActionPayload,
} from '../NinchatClient'
import {NinchatStore} from 'api/types'
import {extractProperties} from '.'

const eventTypePrefix = 'NINCHAT/event'

type ChannelJoinedAsyncThunk = typeof thunk & {reducer: CaseReducer} & ChannelJoinedActionCreator
type ChannelJoinedActionCreator = ActionCreatorWithPayload<NinchatEventActionPayload<NinchatChannelJoinedEvent>, 'NINCHAT/event/channel_joined'>

const thunk = createAsyncThunk<NinchatChannelJoinedEvent, NinchatChannelJoinedEvent>(
    `${eventTypePrefix}/${NinchatEventType.NinchatChannelJoinedEvent}`,
    (event, _) => event,
)

export const channelJoined = thunk as ChannelJoinedAsyncThunk

channelJoined.reducer = (state, action) => {
    const payload = Array.isArray(action.payload)
        ? action.payload.find((p) => p.event === NinchatEventType.NinchatChannelJoinedEvent)
        : action.payload
    const {
        channel_id,
        channel_members,
        ...properties
    } = extractProperties<NinchatChannelJoinedEvent>(payload)

    const _channel_members: NinchatStore.NinchatChannelMembersStore = {}

    for (const user_id of Object.keys(channel_members ?? {})) {
        const {
            user_attrs,
            ...channel_member
        } = channel_members?.[user_id] ?? {}

        if (user_id === state.user_id) {
            state.user_attrs = user_attrs ?? {}
        } else {
            state._users[user_id] ??= {} as NinchatStore.NinchatStoreUser
            state._users[user_id].user_attrs = user_attrs ?? {}
        }

        _channel_members[user_id] = channel_member
    }

    state.user_channels[channel_id] = {
        ...properties,
        channel_member_count: Object.keys(_channel_members).length,
        channel_members: _channel_members,
    }
}
